import { useState } from 'react';
import { supabase } from './supabase';

export default function Auth({ defaultMode = 'signin', onBack }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [isSignup, setIsSignup] = useState(defaultMode === 'signup');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (isSignup) {
      const { error } = await supabase.auth.signUp({
        email,
        password,
        options: { data: { full_name: name } }
      });
      if (error) setError(error.message);
      else setError('Check your email to confirm your account!');
    } else {
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) setError(error.message);
    }
    setLoading(false);
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(145deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)', position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', top: -120, right: -120, width: 400, height: 400, borderRadius: '50%', background: 'radial-gradient(circle, rgba(59,130,246,0.12) 0%, transparent 70%)' }} />
      <div style={{ position: 'absolute', bottom: -80, left: -80, width: 300, height: 300, borderRadius: '50%', background: 'radial-gradient(circle, rgba(20,184,166,0.1) 0%, transparent 70%)' }} />

      <form onSubmit={handleSubmit} style={{ width: 400, padding: 40, background: 'rgba(30,41,59,0.7)', backdropFilter: 'blur(20px)', borderRadius: 20, border: '1px solid rgba(255,255,255,0.06)', boxShadow: '0 25px 60px rgba(0,0,0,0.4)', position: 'relative', zIndex: 1 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          {onBack && (
            <div onClick={onBack} style={{ position: 'absolute', top: 16, left: 20, color: '#64748b', cursor: 'pointer', fontSize: 13 }}>← Back</div>
          )}
          <div style={{ fontSize: 32, fontWeight: 800, background: 'linear-gradient(135deg, #3B82F6, #14B8A6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', letterSpacing: -1, fontFamily: "'Outfit', sans-serif" }}>Folio</div>
          <p style={{ color: '#64748b', fontSize: 14, marginTop: 6 }}>{isSignup ? 'Create your account' : 'Welcome back'}</p>
        </div>

        {error && (
          <div style={{ padding: '10px 14px', borderRadius: 8, marginBottom: 16, fontSize: 13, background: error.includes('Check your email') ? 'rgba(20,184,166,0.1)' : 'rgba(239,68,68,0.1)', color: error.includes('Check your email') ? '#14B8A6' : '#ef4444' }}>
            {error}
          </div>
        )}

        {isSignup && (
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 11, color: '#64748b', display: 'block', marginBottom: 6, fontWeight: 500, textTransform: 'uppercase', letterSpacing: 1 }}>Full Name</label>
            <input value={name} onChange={e => setName(e.target.value)} style={{ width: '100%', padding: '12px 16px', background: 'rgba(15,23,42,0.6)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 10, color: '#e2e8f0', fontSize: 14, outline: 'none', boxSizing: 'border-box' }} placeholder="Your name" />
          </div>
        )}

        <div style={{ marginBottom: 16 }}>
          <label style={{ fontSize: 11, color: '#64748b', display: 'block', marginBottom: 6, fontWeight: 500, textTransform: 'uppercase', letterSpacing: 1 }}>Email</label>
          <input type="email" required value={email} onChange={e => setEmail(e.target.value)} style={{ width: '100%', padding: '12px 16px', background: 'rgba(15,23,42,0.6)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 10, color: '#e2e8f0', fontSize: 14, outline: 'none', boxSizing: 'border-box' }} placeholder="you@email.com" />
        </div>

        <div style={{ marginBottom: 24 }}>
          <label style={{ fontSize: 11, color: '#64748b', display: 'block', marginBottom: 6, fontWeight: 500, textTransform: 'uppercase', letterSpacing: 1 }}>Password</label>
          <input type="password" required value={password} onChange={e => setPassword(e.target.value)} style={{ width: '100%', padding: '12px 16px', background: 'rgba(15,23,42,0.6)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 10, color: '#e2e8f0', fontSize: 14, outline: 'none', boxSizing: 'border-box' }} placeholder="••••••••" minLength={6} />
        </div>

        <button type="submit" disabled={loading} style={{ width: '100%', padding: 14, background: 'linear-gradient(135deg, #3B82F6, #14B8A6)', border: 'none', borderRadius: 10, color: '#fff', fontSize: 15, fontWeight: 700, cursor: loading ? 'wait' : 'pointer', opacity: loading ? 0.7 : 1, boxShadow: '0 4px 20px rgba(59,130,246,0.3)', fontFamily: "'Outfit', sans-serif" }}>
          {loading ? 'Please wait...' : isSignup ? 'Create Account' : 'Sign In'}
        </button>

        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: '#64748b' }}>
          {isSignup ? 'Already have an account?' : "Don't have an account?"}{' '}
          <span onClick={() => { setIsSignup(!isSignup); setError(''); }} style={{ color: '#3B82F6', cursor: 'pointer', fontWeight: 600 }}>
            {isSignup ? 'Sign in' : 'Sign up'}
          </span>
        </p>
      </form>
    </div>
  );
}
